import React from 'react'
import styled from '@emotion/styled'
import {FilterSource} from 'components/Accommodation/OffersFilters/constants'
import {SoldOutBase} from 'components/Unavailability/SoldOut/SoldOutBase'
import {useHotelOverlayOffersFilters} from 'hooks/useHotelOverlayOffersFilters'

import {Button} from '@vio/atlas/Button'
import {Card} from '@vio/atlas/Card'
import {Box} from '@vio/atlas/helpers/Box'
import {cssTheme} from '@vio/atlas/themes'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  source: FilterSource
}

const RemoveFiltersButton = styled(Button)`
  display: block;
  margin-top: ${cssTheme.layout.spacing.s400};
`

const UnavailabilityWrapper = styled(Card)`
  margin-top: ${cssTheme.layout.spacing.s500};
`

export const UnavailabilityWithFilters = ({source}: Props) => {
  const {setFilters} = useHotelOverlayOffersFilters()

  const onRemoveFilters = () => {
    setFilters([], source)
  }

  return (
    <UnavailabilityWrapper
      borderRadius="lg"
      borderColorPath="border.neutral.secondary"
      isOverflowHidden={false}
    >
      <Box padding="s400">
        <SoldOutBase
          headerSlot={
            <FormattedMessageWrapper
              id="unavailability.soldOutWithFilters"
              defaultMessage="No deals to show"
            />
          }
          contentSlot={
            <FormattedMessageWrapper
              id="unavailability.soldOutWithFiltersBody"
              defaultMessage="Change or remove applied filters to see the results."
            />
          }
          actionSlot={
            <RemoveFiltersButton
              variant="tertiary"
              fullWidth
              onClick={onRemoveFilters}
            >
              <FormattedMessageWrapper
                id="removeFiltersMessage"
                defaultMessage="Remove filters"
              />
            </RemoveFiltersButton>
          }
        />
      </Box>
    </UnavailabilityWrapper>
  )
}
